export const SET_EVENT_TYPES = 'SET_EVENT_TYPES';

